module.exports = __webpack_public_path__ + "img/red_027.376e9725.png";